module.exports = {

    init: function () {
        
        // console.log('StickyHeader is working...');

        initialize();
        
        // jQuery(window).scroll(function () {
        jQuery(window).on('scroll', function(){
            initialize();
        });

        function initialize() {
            // console.log(jQuery(this).scrollTop());
            var headerWrapper = jQuery("#header-wrapper").outerHeight();
            var headerThreshold = jQuery(".header-threshold").outerHeight();
            
            if ( jQuery(this).scrollTop() > jQuery("#header-wrapper").outerHeight(true) && !jQuery(".header-threshold").hasClass('sticky-active') ) {

                jQuery(".navbar-wrapper").addClass('active');
                jQuery(".header-threshold").addClass('sticky-active');
                if(jQuery(window).width() > 768) {
                    jQuery(".header-threshold").css('margin-bottom', jQuery(".navigation-wrapper").outerHeight());
                } else {
                    jQuery("#header-wrapper").css('margin-bottom', jQuery(".header-threshold").outerHeight());
                }

            } else if ( jQuery(this).scrollTop() <= jQuery("#header-wrapper").outerHeight(true) ) {

                jQuery(".navbar-wrapper").removeClass('active');
                jQuery(".header-threshold").removeClass('sticky-active');
                jQuery(".header-threshold").css('margin-bottom', 0);
                jQuery("#header-wrapper").css('margin-bottom', 0);

            }
        }
        
    }

};